import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { H1 } from '@btc-snxt/ui';
import { useTabsContext } from 'components/Tabs/TabsContext';
import { StyledNewsSettings } from './NewsSettings.style';

const NewsSettings: React.FC = () => {
  const { t } = useTranslation();

  const tabsContext = useTabsContext();

  useEffect(() => {
    tabsContext.setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <StyledNewsSettings>
        <H1>{t('settings.news')}</H1>
      </StyledNewsSettings>
    </>
  );
};

export default NewsSettings;
